import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectControl } from '../../../create-request/models/OptionDropdownSelect';
import { createControl } from '../../../create-request/utilities/formUtilities';
import * as SelectModels from '../../controlModels/selectModels';
import { CheckTransactionDetailsForm, ItTransactionDetailsForm } from '../../../create-request/models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-pay-income-selector',
  templateUrl: './pay-income-selector.component.html',
  styleUrls: ['./pay-income-selector.component.scss']
})
export class PayIncomeSelectorComponent implements OnInit {
  @Input() parentForm: FormGroup<ItTransactionDetailsForm | CheckTransactionDetailsForm>;
  payIncomeModel: SelectControl = SelectModels.payIncomeModel;
  formControlName: string = 'payIncome';

  constructor() { }

  ngOnInit(): void {
    createControl(this.parentForm, this.formControlName, '');
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('payIncome');
  }

  get payIncome(): FormControl<string> {
    return this.parentForm.get(this.formControlName) as FormControl<string>;
  }
}
